/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Loader, Modal, Checkbox, List, Icon, Popup
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
//import { Scrollbars } from 'react-custom-scrollbars-2';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import Update from 'immutability-helper';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
//import progress from '../../images/icons/progress_ica.gif';
//import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';
import './SystemSettings.css';

class LoadBalancerSystem extends Component {
  constructor(props) {
    super(props);
    this.modalBody = '';
    this.modalAction = '';
    this.modalSubBody = '';
    this.state = {
      isPageLoading: false,
      isLoading: false,
      isModalLoading: false,
      isOpenModal: false,
      isOpenAlertModal: false,
      isErrorLoading: false,
      isLoadBalanceError: false,
      isUseLoadBalance: false,
      errorMsg: '',
      ipAddr: '',
      ipAddrError: '',
      ipsArray: [],
      schemeArray: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.setLoadBalanceSettings = this.setLoadBalanceSettings.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.handlePushValue = this.handlePushValue.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLoadBalanceToggle = this.handleLoadBalanceToggle.bind(this);
    this.handleSchemeCheckChange = this.handleSchemeCheckChange.bind(this);
    this.validation = this.validation.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { location } = this.props;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getLoadBalanceSettings();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.location && location) {
      const currentPath = location.pathname ? location.pathname : location;
      const prevPath = prevProps.location.pathname ? prevProps.location.pathname : prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredAdmin();
      }
    }
  }

  componentWillUnmount() {
  }

  handleSchemeCheckChange(e, { value }) {
    const { schemeArray } = this.state;
    let newState;
    if (schemeArray.indexOf(value) > -1) {
      newState = schemeArray.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...schemeArray, value];
    }
    this.setState({
      schemeArray: newState,
    });
  }

  handleLoadBalanceToggle(e) {
    const { isUseLoadBalance } = this.state;

    if (e.target.text === 'On') {
      if (isUseLoadBalance) {
        return;
      }
      return this.setState({
        isUseLoadBalance: true,
      });
    }
    if (!isUseLoadBalance) {
      return;
    }
    return this.setState({
      isUseLoadBalance: false,
    });
  }

  handleInputChange(e) {
    this.setState({
      ipAddr: e.target.value,
      ipAddrError: '',
    });
  }

  handlePushValue(e) {
    const { ipsArray, ipAddr } = this.state;
    const { t } = this.props;
    // eslint-disable-next-line no-useless-escape, prefer-regex-literals
    const regexDomain = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
    if (e.key === 'Enter') {
      //if (!regexIpv.test(ipAddr) && !regexDomain.test(ipAddr) && ipAddr !== 'localhost') {
      //        return this.setState({
      //ipAddrError: 'Invalid IP Address or Domain.',
      //        });
      if (!this.validateIpAndPort(ipAddr) && ipAddr !== 'localhost' && !ipAddr.match(regexDomain)) {
        return this.setState({
          ipAddrError: t('system.message.invalid_address_domain'),
        });
      }
      if (ipsArray.indexOf(ipAddr) > -1) {
        return this.setState({
          ipAddrError: t('system.message.already_existed_ip'),
        });
      }
      this.setState({
        ipsArray: Update(ipsArray, {
          $push: [ipAddr],
        }),
        ipAddr: '',
      });
    }
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onSubmit() {
    const { t } = this.props;
    if (!this.validation()) {
      return;
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.q_save_load_balance');

    this.setState({
      isOpenModal: true,
      isModalLoading: false,
      isErrorLoading: false,
    });
  }

  setLoadBalanceSettings() {
    const { schemeArray, isUseLoadBalance, ipsArray } = this.state;
    const { t, navigate } = this.props;
    let obj;

    if (isUseLoadBalance) {
      obj = {
        scheme: schemeArray,
        is_primary: isUseLoadBalance,
        ips: ipsArray,
      };
    } else {
      obj = {
        scheme: schemeArray,
        is_primary: isUseLoadBalance,
        ips: [],
      };
    }

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setLoadBalanceSettings(obj)
        .then(() => {
          //console.log(res);
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.update_success_load_balance');
          this.modalSubBody = t('system.message.update_success_message');
          this.setState({
            isModalLoading: false,
            isErrorLoading: true,
          });
        })
        .catch((err) => {
          console.log(err);
          if (!err.data) {
            this.modalBody = t('system.message.error_connection_refused');
            return this.setState({
              isModalLoading: false,
              isErrorLoading: true,
            });
          }
          const o = err.data.response;
          const text = o.error_description || null;

          this.modalAction = t('modal.title.attention');

          if (o.error === '422-362') {
            if (this.props.state.user.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (this.props.state.user.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
            }
          }
          if (o.error === '422-366') {
            this.modalBody = text;
            this.modalSubBody = '';
          }

          if (o.error === '422-231') {
            this.modalBody = t('system.message.invalid_address_domain');
            this.modalSubBody = '';
          }

          this.setState({
            isModalLoading: false,
            isErrorLoading: true,
          });
        });
    });
  }

  getLoadBalanceSettings() {
    const { navigate } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getLoadBalanceSettings()
        .then((res) => {
          //console.log(res);
          const data = res.response;
          this.setState({
            isLoading: false,
            schemeArray: data.scheme,
            isUseLoadBalance: data.is_primary,
            ipsArray: data.ips,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          if (o.error === '422-362') {
            if (this.props.state.user.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (this.props.state.user.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
            }
          }

          this.setState({
            isLoading: false,
          });
        });
    });
  }

  clearValue = (index) => {
    const { ipsArray } = this.state;
    const newState = ipsArray.filter((item, i) => {
      return i !== index;
    });

    this.setState({
      ipsArray: newState,
    });
  };

  requiredAdmin() {
    const { state, navigate } = this.props;
    if (!state.user.isAdmin) {
      if (localStorage.getItem('main_page') === 'dashboard') {
        navigate('/main', { replace: true });
      } else if (localStorage.getItem('main_page') === 'results') {
        navigate('/results', { replace: true });
      } else {
        navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
      }
    }
  }

  validation() {
    const { t } = this.props;
    const { schemeArray } = this.state;

    if (schemeArray.length === 0) {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('system.message.select_one_protocol');
      this.setState({
        isOpenAlertModal: true,
      });
      return false;
    }
    return true;
  }

  validateIpAndPort(input) {
    const parts = input.split(':');
    const ip = parts[0].split('.');
    const port = parts[1];

    if (parts.length === 1) {
      const ipOnly = input.split('.');
      return ipOnly.length === 4 && ipOnly.every((segment) => {
        return this.validateNum(segment, 0, 255);
      });
    }
    return this.validateNum(port, 1, 65535) && ip.length === 4 && ip.every((segment) => {
      return this.validateNum(segment, 0, 255);
    });
  }

  validateNum(input, min, max) {
    const num = +input;
    return num >= min && num <= max && input === num.toString();
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenAlertModal: false,
      isErrorLoading: false,
    });
  }

  render() {
    const {
      isLoadBalanceError,
      errorMsg,
      isLoading,
      isModalLoading,
      schemeArray,
      isUseLoadBalance,
      ipAddr,
      ipAddrError,
      ipsArray,
      isErrorLoading,
    } = this.state;
    const { t } = this.props;

    const renderIfReady = (element) => {
      return !isLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const ipAddrErrorClass = ipAddrError !== '' ? 'show' : '';

    return (
      <div>
        <div className="content">
          <div className="setting_small_box setting_small_box_2">
            <h2 className="page_title">
              {t('system.title.web_server_settings')}
              {isLoadBalanceError ? <span className="error">{errorMsg}</span> : null}
            </h2>
            {renderIfReady(
              <div>
                {/**<h2 className="page_title">Update Settings</h2>**/}
                <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                  <div className="setting_contnet_wrap">
                    <h3 className="setting_content_title">{t('system.title.protocol')}</h3>
                    <div className="setting_content">
                      <div className="inline_checkbox">
                        <Checkbox
                          label="Http"
                          value="http"
                          checked={schemeArray.indexOf('http') > -1}
                          onChange={this.handleSchemeCheckChange}
                        />
                        <Checkbox
                          label="Https"
                          value="https"
                          checked={schemeArray.indexOf('https') > -1}
                          onChange={this.handleSchemeCheckChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnet_wrap">
                    <h3 className="setting_content_title">{t('system.title.load_balancer_primary_server')}</h3>
                    <div className="setting_content" style={{ minWidth: '25%', float: 'left', marginTop: '11px' }}>
                      <div className="switch">
                        <a
                          className={cx(
                            {
                              checked: isUseLoadBalance,
                            }
                          )}
                          onClick={this.handleLoadBalanceToggle}
                        >
                          {t('system.button.on')}
                        </a>
                        <a
                          className={cx(
                            {
                              checked: !isUseLoadBalance,
                            }
                          )}
                          onClick={this.handleLoadBalanceToggle}
                        >
                          {t('system.button.off')}
                        </a>
                      </div>
                    </div>
                    <div style={{ width: '100%', display: 'inline-block' }}>
                      {
                        isUseLoadBalance ? (
                          <p className="text">{t('system.message.use_load_balance')}</p>
                        ) : (
                          <p className="text">{t('system.message.not_use_load_balance')}</p>
                        )
                      }
                    </div>
                    {
                      isUseLoadBalance
                      && (
                        <div className="setting_content" style={{ position: 'relative' }}>
                          <Popup
                            trigger={<Icon name="question circle outline" />}
                            content={t('system.message.use_load_balance_ip')}
                            position="top left"
                            size="small"
                            className="question"
                          />
                          <input
                            type="text"
                            style={{ width: '220px' }}
                            value={ipAddr}
                            placeholder={t('system.message.use_load_balance_ip_placeholder')}
                            onChange={this.handleInputChange}
                            onKeyPress={this.handlePushValue}
                          />
                          <div
                            className={`error ${ipAddrErrorClass}`}
                            style={{
                              marginTop: '6px',
                              marginLeft: '5px',
                              fontSize: '12px',
                              fontWeight: '700',
                              color: '#ef4136',
                            }}
                          >
                            {ipAddrError}
                          </div>
                          <List as="ul" className="ip_address">
                            <List.Header style={{ fontWeight: 'bold', lineHeight: '30px' }}>{t('system.title.client_server_list')}</List.Header>
                            <List.Item as="li" style={{ lineHeight: '30px' }}>
                              <List.Content style={{ marginTop: '0' }}>127.0.0.1</List.Content>
                            </List.Item>
                            {
                              ipsArray.map((item, index) => {
                                return (
                                  <List.Item key={uuidv4()} as="li" style={{ lineHeight: '30px' }}>
                                    <List.Content style={{ marginTop: '0' }}>
                                      {item}
                                      <Icon name="close" onClick={() => { return this.clearValue(index); }} />
                                    </List.Content>
                                  </List.Item>
                                );
                              })
                            }
                          </List>
                        </div>
                      )
                    }
                  </div>
                  <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                    <div className="setting_content">
                      <div className="right_box">
                        <a
                          className="update"
                          onClick={this.onSubmit}
                        >
                          {t('modal.button.save')}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <Modal
          open={this.state.isOpenModal}
          //onClose={this.closeModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isErrorLoading
                    && (
                      <p className="small_text">
                        {this.modalSubBody}
                      </p>
                    )
                      }
                      {
                        isErrorLoading ? (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="center_button">
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="left_button">
                              {t('modal.button.no')}
                            </a>
                            <a onClick={this.setLoadBalanceSettings} className="right_button">
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal open={this.state.isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a onClick={this.closeModal} className="center_button">
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LoadBalancerSystem))));
